module.exports = __webpack_public_path__ + "static/img/head.38a37cc3.png";